module.exports = __webpack_public_path__ + "static/media/back3.3706bef3.jpg";